import Header from "@/components/entities/header";
import Title from "@/components/ui/title";
import { Container } from "@/components/ui/container";
import { useTranslations } from "next-intl";
import S from "./index.module.scss";

const SocialHeader = () => {
  const t = useTranslations("social");
  
  return (
    <div className={S.headerWrapper}>
      <Header />
      <Container className={S.infoWrap}>
        <Title variant="black">{t("title")}</Title>
        <p className={S.description}>{t("description")}</p>
      </Container>
    </div>
  );
};

export default SocialHeader;